import { render } from "./ChallengeTypeTag.vue?vue&type=template&id=a505dc4a&scoped=true"
import script from "./ChallengeTypeTag.vue?vue&type=script&lang=js"
export * from "./ChallengeTypeTag.vue?vue&type=script&lang=js"

import "./ChallengeTypeTag.vue?vue&type=style&index=0&id=a505dc4a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a505dc4a"

export default script